angular.module('pitch.app')
    .factory('Favourite', function(config, $http) {
        return {
            addFavourite: function(trackId, pitchHash) {
                return $http({
                    method: 'POST',
                    url: config.apiUri + '/playlists/pitches/' + pitchHash + '/favourites',
                    data: {
                        favourite: trackId
                    }
                });
            },
            deleteFavourite: function(trackId, pitchHash) {
                return $http({
                    method: 'DELETE',
                    url: config.apiUri + '/playlists/pitches/' + pitchHash + '/favourites/' + trackId
                });
            }
        };
    })
;


// WEBPACK FOOTER //
// ./src/AppBundle/Resources/js/angular/services/Favourite.js